import React, { useEffect, useState } from "react";
import { PaperPlaneTilt, Plus, X } from "@phosphor-icons/react";

const RE = /^[^@\s]+@[^@\s]+\.[a-zA-Z]{2,}$/;

export function SendInvoiceDialog({ open, initial, lang, onClose, onSend }) {
  const fr = lang !== "en";
  const [emails, setEmails] = useState([]);
  const [sending, setSending] = useState(false);
  useEffect(() => {
    if (open) { const l = (initial || []).filter(Boolean); setEmails(l.length ? l : [""]); }
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!open) return null;
  const clean = emails.map((e) => e.trim()).filter(Boolean);
  const invalid = clean.some((e) => !RE.test(e));
  const go = async () => { setSending(true); try { await onSend(clean); } finally { setSending(false); } };
  return (
    <div data-testid="send-invoice-dialog" className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4" onClick={onClose}>
      <div className="w-full max-w-md border border-border bg-card p-6 shadow-xl" onClick={(e) => e.stopPropagation()}>
        <div className="mb-1 font-display text-xl font-bold">{fr ? "Envoyer la facture à" : "Send invoice to"}</div>
        <p className="mb-4 text-xs text-muted-foreground">{fr ? "La facture partira à toutes les adresses ci-dessous. Effacez celles à exclure." : "The invoice will be sent to every address below. Remove the ones to exclude."}</p>
        <div className="space-y-2">
          {emails.map((e, i) => (
            <div key={i} className="flex items-center gap-2">
              <input data-testid={`send-email-${i}`} type="email" value={e} placeholder={fr ? `Courriel ${i + 1}` : `Email ${i + 1}`}
                onChange={(ev) => setEmails(emails.map((x, j) => (j === i ? ev.target.value : x)))}
                className={`w-full border bg-background px-3 py-2 text-sm outline-none focus:border-primary ${e.trim() && !RE.test(e.trim()) ? "border-red-400" : "border-border"}`} />
              <button data-testid={`send-email-remove-${i}`} onClick={() => setEmails(emails.filter((_, j) => j !== i))} className="p-2 text-red-500 hover:bg-red-50" aria-label="remove"><X size={16} weight="bold" /></button>
            </div>
          ))}
        </div>
        <button data-testid="send-email-add" onClick={() => setEmails([...emails, ""])} className="mt-2 inline-flex items-center gap-1 text-xs font-bold uppercase tracking-wider text-primary"><Plus size={14} weight="bold" /> {fr ? "Ajouter une adresse" : "Add an address"}</button>
        <div className="mt-6 flex justify-end gap-3">
          <button data-testid="send-invoice-cancel" onClick={onClose} className="border border-border px-4 py-2 text-xs font-bold uppercase tracking-wider">{fr ? "Annuler" : "Cancel"}</button>
          <button data-testid="send-invoice-confirm" disabled={!clean.length || invalid || sending} onClick={go}
            className="inline-flex items-center gap-2 bg-primary px-4 py-2 text-xs font-bold uppercase tracking-wider text-white disabled:opacity-50">
            <PaperPlaneTilt size={14} weight="bold" /> {sending ? "…" : `${fr ? "Envoyer" : "Send"} (${clean.length})`}
          </button>
        </div>
      </div>
    </div>
  );
}
